import classNames from 'classnames';
import React, { type ReactNode } from 'react';
import { Body3 } from '../../typography';
import {
  styledOrderedList,
  styledUnorderedList,
  type OrderedListVariant,
  type UnorderedListVariant,
} from './List.css';

type ListContainerProps = {
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

type ListItemProps = {
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

export const ListItem: React.FC<ListItemProps> = (props) => {
  const { children, style, className, ...rest } = props;

  return (
    <li className={classNames(className)} style={style} {...rest}>
      <Body3 variant="inherit">{children}</Body3>
    </li>
  );
};

export const OrderedList: React.FC<ListContainerProps & OrderedListVariant> = (
  props,
) => {
  const { children, className, style, ...rest } = props;

  return (
    <ol
      className={classNames(styledOrderedList({ ...rest }), className)}
      style={style}
      {...rest}
    >
      {children}
    </ol>
  );
};

export const UnorderedList: React.FC<
  ListContainerProps & UnorderedListVariant
> = (props) => {
  const { children, className, style, ...rest } = props;

  return (
    <ul
      className={classNames(styledUnorderedList({ ...rest }), className)}
      style={style}
      {...rest}
    >
      {children}
    </ul>
  );
};
